import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NavBar = ({ textes, isBackgroundWhite = false, initVisible = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <motion.nav
      initial={{ y: initVisible ? 0 : -200 }}
      animate={{ y: initVisible ? 0 : isScrolled ? 0 : -200 }}
      transition={{ duration: 0.5 }}
      className={
        "fixed top-0 left-0 w-screen bg-black bg-opacity-0 z-40 flex justify-center items-center nav-bar"
      }
    >
      <div className="container mx-auto flex items-center justify-between py-4 px-24">
        <div className="flex items-center">
          <Link
            to={"/"}
            className={
              "font-sam text-[6em] font-thin " + (isBackgroundWhite ? "text-black" : "text-white")
            }
          >
            SAM
          </Link>
        </div>
        <ul className="flex items-center ml-auto">
          <li
            className={
              "mx-5 font-lexend text-[2.5em] hover:text-[#039b7c]" +
              (isBackgroundWhite ? " text-black" : " text-white")
            }
          >
            <Link to={"/#" + textes?.navBarItem2}>{textes?.navBarItem2}</Link>
          </li>
          <li
            className={
              "mx-5 font-lexend text-[2.5em] hover:text-[#039b7c]" +
              (isBackgroundWhite ? " text-black" : " text-white")
            }
          >
            <Link to="/contact">{textes?.navBarItem1}</Link>
          </li>
        </ul>
      </div>
    </motion.nav>
  );
};

export default NavBar;
